module.exports = __webpack_public_path__ + "img/ico-add-photo.8f781971.svg";